<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="projeTanimlama"> Proje Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="projeListesi"> Proje Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="projeDetay"> Proje Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="projeDurumGuncelle"> Proje Durum Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="projeGuncelle"> Proje Guncelle
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import projeService from '../../../WSProvider/ProjeService';
    import notification from '../../../notification'
    import Proje from "./Proje";
    export default {
        name: "ProjeDetay",
        methods: {
            projeTanimlama() {
                projeService.projeTanimlama('HBT0001','PK-64000','link1234','baslik','altbaslik','icerik',["ygy","hgh"],'','','','url','2020-06-25','2020-06-27',1,1,'seobaslik','seoicerik');
            },
            projeDurumGuncelle() {
                projeService.projeDurumGuncelle('HBT0001','HK-1000',0);
            },
            projeListesi() {
                projeService.projeListesi('HBT0001',1);
            },
            projeDetay() {
                projeService.projeDetay('HK-1000');
            },
            projeGuncelle() {
                let updateList = [{
                    type: "link",
                    value: "llll5236"
                }];
                projeService.projeGuncelle('HBT0001','PJ-64008',updateList);
            }

        }
    }
</script>

<style scoped>

</style>